import React, { Component } from 'react';
import { connect } from 'dva';
import { TreeSelect } from 'antd';
const { TreeNode } = TreeSelect;

@connect(({ baseSetting }) => ({
  ...baseSetting,
}))

class RoleSelect extends Component {

  componentWillMount() {
    const { dispatch } = this.props;
    dispatch({
      type: 'baseSetting/fetchGroupTree'
    })
  }

  onChange = (groupSelectTreeNode) => {
    const { dispatch } = this.props;
    dispatch({
      type: 'baseSetting/save',
      payload: {
        groupSelectTreeNode,
      }
    });
  };

  onTreeExpand = groupTreeExpandedKeys => {
    const { dispatch } = this.props;
    dispatch({
      type: 'baseSetting/save',
      payload: {
        groupTreeExpandedKeys
      }
    });
  };

  treeRecursionFun(data) {
    return (
      <TreeNode value={`${data.id}`} title={data.name} key={data.id} treeNodeData={data}>
        {
          (data.children || []).map(items => {
            return this.treeRecursionFun(items)
          })
        }
      </TreeNode>
    )
  }

  render() {
    const { groupTreeData, groupSelectTreeNode, groupTreeExpandedKeys } = this.props;
    const tProps = {
      value: groupSelectTreeNode,
      treeExpandedKeys: groupTreeExpandedKeys,
      onChange: this.onChange,
      onTreeExpand: this.onTreeExpand,
      treeCheckable: true,
      treeCheckStrictly: true,
      searchPlaceholder: '请选择',
      dropdownClassName: 'personnel-edit-dropdown',
      // style: {
      //   width: 300,
      // },
    };

    return (
      <TreeSelect {...tProps}>
        {
          this.treeRecursionFun(groupTreeData)
        }
      </TreeSelect>

    );
  }
}

export default RoleSelect;
